import { render, staticRenderFns } from "./ReportsPagination.vue?vue&type=template&id=6f3984a9&scoped=true&"
import script from "./ReportsPagination.vue?vue&type=script&lang=js&"
export * from "./ReportsPagination.vue?vue&type=script&lang=js&"
import style0 from "./ReportsPagination.vue?vue&type=style&index=0&id=6f3984a9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3984a9",
  null
  
)

export default component.exports